import { Component, input } from '@angular/core';
import { AbstractControl, FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'htx-checkbox-field',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './checkbox-field.component.html',
  styleUrl: './checkbox-field.component.scss',
})
export class CheckboxFieldComponent {
  /** The FormControl that manages the checkbox value and validation state */
  ctrl = input.required<AbstractControl>();

  /** The label text displayed next to the checkbox */
  label = input<string>();

  /** Whether the checkbox is required and should display a red asterisk indicator */
  required = input<boolean>(false);

  /**
   * Returns the control as a FormControl for direct access to its properties and methods.
   * This allows the template to check error states and validation properties.
   */
  getControl(): FormControl {
    return this.ctrl() as FormControl;
  }
}
